import { NgModule } from '@angular/core';
import { ActionReducer, StoreModule } from '@ngrx/store';
import { StateSlice } from '../state-slice';
import { reducer } from './profile-reducer';
import { initialProfileState } from './profile-state';
import { combineReducers } from '@core/utils/state';
import { EffectsModule } from '@ngrx/effects';
import { ProfileEffects } from './profile-effects';

@NgModule({
    imports: [
      // HttpClientModule,
      StoreModule.forFeature(StateSlice.PROFILE, (reducer as ActionReducer<any, any>), {
        initialState: initialProfileState,
        reducerFactory: combineReducers
      }),
      EffectsModule.forFeature([ ProfileEffects ])
    ],
    declarations: []
  })
  export class ProfileStateModule {}
